import {Sale} from './Sale';
import {Price} from './Price';
import {Header} from './Header';
import {Button} from './Button';
import {Footer} from './Footer';
import {Loader} from './Loader';
import {Status} from './Status';
import {Rating} from './Rating';
import {Select} from './Select';
import {Container} from './Container';
import {StarRating} from './StarRating';
import {RatingStars} from './RatingStars';
import {BlockHeading} from './BlockHeading';
import {ImageBackground} from './ImageBackground';

export const components = {
  Sale,
  Price,
  Header,
  Button,
  Loader,
  Footer,
  Rating,
  Select,
  Status,
  Container,
  StarRating,
  RatingStars,
  BlockHeading,
  ImageBackground,
};
